<div class="documents">
  <h1>Select file</h1>
  <ri-filemanager [selectOnly]="true" (externalFolderSelect)="onFolderSelected($event)" [mode]="'1'"
                  style="display: block;">Loading...
  </ri-filemanager>
  <div style="margin-left: 20px;">
    <button mat-raised-button style="margin-right: 18px;" (click)="onDone()">Select Folder</button>
    <button mat-raised-button (click)="onClose()">Close</button>
  </div>
</div>
